<script setup lang="ts">
    import KAutocomplete from "@/components/forms/inputs/Autocomplete/KAutocomplete.vue";
    import { defaultAutocompleteConverter } from "@/components/forms/inputs/Autocomplete/helpers";
    import { flashWarning } from "@/utils";
    import { getConfig, klinikenApi } from "@/api";

    const fetchSprak = async ({ query }: { query?: string } = {}) => {
        try {
            const response = await klinikenApi.get("/core/kodverk/iso_639_1/", getConfig());

            return response.data.results.map((item: { code: string; displayName: string }) => ({
                value: item.code,
                label: item.displayName,
            }));
        } catch (error) {
            flashWarning("Kunde inte hämta språk");
        }
    };
</script>

<template>
    <KAutocomplete
        name="sprak"
        label="Språk"
        v-bind="$attrs"
        :options="fetchSprak"
        :onSearch="fetchSprak"
        :converter="defaultAutocompleteConverter"
    />
</template>

<style lang="scss" scoped></style>
